export const dealersActions = {
    DEALERS_REQUEST_TO_BID_SET_REQUEST_STATUS: 'DEALERS_REQUEST_TO_BID_SET_REQUEST_STATUS',
    DEALERS_RESET_STATE: 'DEALERS_RESET_STATE',
    DEALERS_SHOW_CONFIRM_BID_REQUEST_POPUP: 'DEALERS_SHOW_CONFIRM_BID_REQUEST_POPUP',
    DEALERS_HIDE_CONFIRM_BID_REQUEST_POPUP: 'DEALERS_HIDE_CONFIRM_BID_REQUEST_POPUP',
};
